module.exports = __webpack_public_path__ + "static/media/Map_base.077b8a16.svg";